import React from 'react';
import styled from 'styled-components';
import CertificateMultiIcon from 'images/claims/certificates.svg';
import CertificateIcon from 'images/claims/certificate.svg';
import TagIcon from 'images/icons/tag.svg';
import CalendarIcon from 'images/icons/calendar.svg';
import ExternalLinkIcon from 'images/icons/external_link.svg';
import { useTheme } from 'styled-components';
import { DocumentVisibilityStatus } from 'types/types';
import { useTranslation } from 'react-i18next';
import { formatDateString } from 'utils/date';
const Container = styled.a `
  display: flex;
  justify-content: flex;
  align-items: center;
  grid-gap: 10px;
  background: ${({ theme, disabled }) => disabled ? theme.palette.grey['200'] : 'white'};
  box-shadow: ${({ theme, disabled }) => disabled ? 'none' : theme.shadows[0]};
  border-left: 8px solid transparent;
  width: 100%;
  border-radius: 6px;
  padding: 8px 16px;
  box-sizing: border-box;
  text-decoration: none;
  overflow: hidden;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'initial')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${({ isActive, theme }) => isActive &&
    `
    border-left-color: ${theme.palette.grey.A800};
  `}
`;
const TitleContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;
const Title = styled.span `
  color: #000;
  font-weight: ${({ bold }) => (bold ? 700 : 400)};
  font-size: 14px;
`;
const SubTitle = styled.span `
  color: ${({ theme }) => theme.palette.grey.A300};
  font-weight: ${({ bold }) => (bold ? 700 : 400)};
  font-size: 11px;
  display: flex;
  align-items: center;
  grid-gap: 14px;
`;
const DocumentIconContainer = styled.div `
  min-width: 24px;
  display: flex;
  justify-content: center;
`;
const SubtitleWithIcon = styled.div `
  display: flex;
  align-items: center;
  grid-gap: 4px;

  span {
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
const DocumentContainer = ({ children, multi = false, onDocumentClick, document, active = false, }) => {
    const { t } = useTranslation();
    const { palette: { primary: { main: themeColor }, grey: { A300 }, }, backgrounds: { grey }, } = useTheme();
    const documentIsPublic = (document === null || document === void 0 ? void 0 : document.visibility) === DocumentVisibilityStatus.PUBLIC;
    const canClick = multi || documentIsPublic;
    return (React.createElement(Container, { href: canClick ? document === null || document === void 0 ? void 0 : document.url : '', disabled: !canClick, target: document && '_blank', onClick: canClick ? onDocumentClick : undefined, isActive: active, "data-cy": "proof-document" },
        React.createElement(DocumentIconContainer, null, multi ? (React.createElement(CertificateMultiIcon, { color: themeColor })) : (React.createElement(CertificateIcon, { color: themeColor }))),
        React.createElement(TitleContainer, null,
            React.createElement(Title, { bold: !!document }, document && !documentIsPublic
                ? t('impact-claims.private-document')
                : children),
            !multi &&
                (documentIsPublic ? (document && (React.createElement(SubTitle, { bold: true },
                    document.category && (React.createElement(SubtitleWithIcon, null,
                        React.createElement(TagIcon, { color: A300 }),
                        React.createElement("span", { title: t(`document-category.${document.category}`) }, t(`document-category.${document.category}`)))),
                    document.issuedDate && (React.createElement(SubtitleWithIcon, null,
                        React.createElement(CalendarIcon, { color: A300 }),
                        React.createElement("span", null, formatDateString(document.issuedDate))))))) : (React.createElement(SubTitle, null, t('impact-claims.private-document-subtitle'))))),
        canClick && React.createElement(ExternalLinkIcon, { color: grey })));
};
export default DocumentContainer;
